import {
  Box,
  Paper,
  TextField,
  FormControl,
  FormHelperText,
  FormLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { get } from 'lodash';
import { ReactElement } from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';

import { ImageUpload } from '@app/components/Shared/Inputs/ImageUpload';
import { PROPERTY_VARIANT_PLOT_MAP_CATEGORY_VALUES as CATEGORY_VALUES } from '@app/utils/constants';
import { getResizeImageURL } from '@app/utils/fileUpload';

export function PlotMapFormSection(): ReactElement {
  const {
    clearErrors,
    control,
    formState: { errors },
    setError,
    setValue,
    watch,
  } = useFormContext();
  const { fields } = useFieldArray({
    control,
    name: 'plotMaps',
  });

  return (
    <Stack spacing={3}>
      <Typography variant="h5">区画図</Typography>
      {fields.map((field, index) => (
        <Stack key={field.id} spacing={1.5}>
          <Paper variant="outlined" sx={{ p: 3 }}>
            <Stack direction="row" spacing={3} useFlexGap>
              <Box flex={1}>
                <ImageUpload
                  fileInfo={watch(`plotMaps.${index}.url`)}
                  onFileUpload={async (urls) => {
                    const resizeUrl = await getResizeImageURL(
                      urls[0],
                      undefined,
                      undefined,
                      3 / 2
                    );
                    clearErrors(`plotMaps.${index}`);
                    setValue(`plotMaps.${index}.imageId`, '');
                    setValue(`plotMaps.${index}.url`, resizeUrl);
                  }}
                  onError={(e) =>
                    setError(`plotMaps.${index}`, { message: e.message })
                  }
                />
                {Array.from(
                  new Set([get(errors, `plotMaps.${index}.message`, '')])
                )
                  .filter((m) => !!m)
                  .map((message, index) => (
                    <FormHelperText key={index} error>
                      {message as string}
                    </FormHelperText>
                  ))}
              </Box>
              <Stack spacing={1.5} flex={1}>
                <FormControl fullWidth>
                  <FormLabel focused={false}>画像カテゴリー</FormLabel>
                  <Controller
                    name={`plotMaps.${index}.customFields.category`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Select {...field} error={!!error} displayEmpty>
                        {Object.keys(CATEGORY_VALUES)
                          .sort((a, b) => a.localeCompare(b))
                          .map((key, index) => (
                            <MenuItem key={index} value={key}>
                              {CATEGORY_VALUES[key]}
                            </MenuItem>
                          ))}
                      </Select>
                    )}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <FormLabel focused={false}>説明本文</FormLabel>
                  <Controller
                    name={`plotMaps.${index}.description`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        error={!!error}
                        helperText={error?.message}
                        multiline
                      />
                    )}
                  />
                </FormControl>
              </Stack>
            </Stack>
          </Paper>
        </Stack>
      ))}
    </Stack>
  );
}
